module.exports = __webpack_public_path__ + "assets/images/img/invite_players/settings_ios_privacy.925ebe9a12dfd5554f2fb6cdf40f05e0.png";